class ResponseMaker {
    data = [];
    data_to_send = {};

    constructor(data) {
        this.data = data;
    }

    process = () => {
        if (this.data.data !== undefined && this.data.data.ship_to !== undefined &&
            typeof this.data.data.ship_to === 'object' && this.data.data.ship_to.length > 0
        ) {
            let d = [];
            this.data.data.ship_to.map((v, i) => {
                v.addressLine = v.address_line;
                v.cityName = v.city_name;
                v.countryCode = v.country_code;
                v.cityName = v.city_name;
                v.countrySubDivisionCode = v.country_subdivision_code;
                v.postalCode = v.postal_code;
                v.shipToAddressId = v.ship_to_id;
                d.push(v)
            });
            this.data_to_send = d;
        }
        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}

export default ResponseMaker;